export default __webpack_public_path__ + "static/media/Navbharat.ce12d87c.jpg";